import {createStore} from '../utilities/storeUtils';
import  _ from 'underscore';
import {cmrDomainsKeyToArrayOfCmrDomains} from './relationships';
import {toCurrency} from "../utilities/currency";
/*

let cmrDomains = {
  1: {
    id: 1,
    cdm_domain: "shipment_level_services",
    cdm_meaning: "25 % quality Audit",
    cdm_description: 0.53
  },
  2: {
    id: 2,
    cdm_domain: "item_level_services",
    cdm_meaning: "polybag - small",
    cdm_description: 0 // this is free, convert to 1 during math calculation
  },
  3: {
    id: 3,
    cdm_domain: "item_level_services",
    cdm_meaning: "polybag - large",
    cdm_description: 2.2
  },
  4: {
    id: 4,
    cdm_domain: "item_level_services",
    cdm_meaning: "polybag - huge",
    cdm_description: 0.3
  },
  5: {
    id: 5,
    cdm_domain: "shipment_level_services",
    cdm_meaning: "50 % quality Audit",
    cdm_description: 0.79
  },
  6: {
    id: 6,
    cdm_domain: "barcode_item_level_mandatory_services",
    cdm_meaning: "Barcode printing charge",
    cdm_description: .5 
  },
  7: {
    id: 7,
    cdm_domain: "fragile_item_level_mandatory_services",
    cdm_meaning: "Fragile item handling charge",
    cdm_description: 0.2 
  }
};


// let cmrDomains = {};

*/

let cmrDomains = {};


const defaults = {

};

const CmrDomainStore = createStore({
  storeEventBaseKey: "cmr_domains",
  normalizr: cmrDomainsKeyToArrayOfCmrDomains,
  normalizrKey: "cmrDomains",
  getData(){
    return cmrDomains;
  },
  getDefaults(){
    return defaults;
  },
  getOnlyProductServiceLevels(){
    return this.getOnlyServiceLevelsWith( "item_level_services");
  },
  getOnlyShipmentServiceLevels(){
    return this.getOnlyServiceLevelsWith("shipment_level_services");
  },
  getOnlyServiceLevelsWith(serviceLevel){
    return _.chain(this.getData()).values().where({cdm_domain: serviceLevel}).value();
  },
  currencyToHtml(domain){
    if(domain.cdm_description === 0 || domain.cdm_description === "0"){
      return "FREE";
    }
    return toCurrency(domain.cdm_description);
  },
  getTitle(domain){
    return domain.cdm_meaning;
  },
  getValue(domain){
    return domain.cdm_description;
  },
  isMandatoryDomain(domain){
    return !!/_level_mandatory_services$/.test(domain.cdm_domain);
  },
  groupByCdmDomain(){
    return _.chain(this.getData()).values().groupBy((domain)=>{return domain.cdm_domain}).value();
  }
});

window.CmrDomainStore = CmrDomainStore;
export default CmrDomainStore;


// WEBPACK FOOTER //
// ./src/stores/CmrDomainStore.js